module.exports = __webpack_public_path__ + "static/img/a009.a7725cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a009.jpg
// module id = 4EOd
// module chunks = 0